import { Random, Utile } from 'utils';
export default {
  props: {
    trColorStatus: {
      type: Boolean,
      default: false
    },
    timeLodingStatus: {
      type: Number
    },
    showModal: {
      type: Boolean,
      default: false
    },
    listPeriodData: {
      type: Object,
      default: {}
    },
    data: Object,
  },
  data () {
    return {
      notFoundText: '无匹配数据'
    }
  },
  computed: {
    BallNumberList () {
      return Utile.ArrayRange(...this.NumberBallRange).reverse()
    }
  },
  watch: {
    Select (val) {
      if (val.every(it => it === '-') || (this.gameid == 202 && val.includes('-'))) {
        this.$emit('changeButtonSendStatus', true)
      } else {
        this.$emit('changeButtonSendStatus', false)
      }
    },
    showModal: {
      immediate: true,
      handler (val) {
        if (val && this.data.mark) this.SetNumberMark(this.data)
      }
    },
    timeLodingStatus (val) {
      if (val === 2) {
        // 下拉選單 visible
        this.$refs.Select.map(it => {
          it.visible = false
        })
      }
    }
  },
  methods: {
    NumberSelect (value) { // 判断 Select 已选取号码, 其他Select移除 
      const result = this.BallNumberList.filter(it => {
        if (this.BallAll) return it
        if (value == it) return it // 判断如果是已选取号码就不移除
        if (this.Select.includes(it)) return
        return it
      })
      return result
    },
    RandomNumber () { // 取得乱码数塞入
      this.Select = Random.Number(this.NumberLength, this.NumberBallRange)
    },
    removeNumber () { // 重置号码
      this.Select = this.Select.map(it => it = '-')
    },
    queryChange (val) { // Select 搜寻时判断
      if (this.Select.some(it => it == val)) return this.notFoundText = '号码不可重复！'
      if (this.BallNumberList.some(it => it != val)) return this.notFoundText = '号码错误！'
      if (this.BallNumberList.some(it => it == val) || val == '未指定') return this.notFoundText = '无匹配数据'
    },
    GetNumberMark () { // 回传所选号码
      if (this.Select.length != this.NumberLength) {
        this.$Message.warning('号码总数错误')
        return false
      } else {
        return this.Select.join(',')
      }
    },
    SetNumberMark (value) {
      if (!value.mark) return
      this.Select = value.mark.slice()
    },
    GetRTP () { // 取得 設定的RTP參數，若無參數則回傳 null
      if (!this.theadBottom || !this.theadBottom.rtp.value) return null
      return this.theadBottom.rtp.value
    }
  }
}